/**
 * Shared "nothing here yet" block for list pages, replacing plain `<p>No X
 * found.</p>` text with an icon + message + optional call-to-action link.
 */
import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

export interface EmptyStateAction {
  label: string;
  to: string;
}

export interface EmptyStateProps {
  icon: LucideIcon;
  message: string;
  action?: EmptyStateAction | undefined;
}

export function EmptyState({ icon: Icon, message, action }: EmptyStateProps): React.JSX.Element {
  return (
    <div className="empty-state">
      <Icon size={32} className="empty-state__icon" aria-hidden="true" />
      <p className="empty-state__message">{message}</p>
      {action !== undefined && (
        <Link to={action.to} className="button button--outlined">
          {action.label}
        </Link>
      )}
    </div>
  );
}

export default EmptyState;
